import axios from 'axios';

// Use environment variable for API URL, fallback to production domain
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://esevalink.com/api';

const API = axios.create({
  baseURL: API_BASE_URL,
});

// ✅ Attach token to every admin request
API.interceptors.request.use((req) => {
  const token = localStorage.getItem('eseva_token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

export default API;
